import styled from 'styled-components';

export const EventLogCard = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	overflow: hidden;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.5rem;
	background: ${({ theme }) => theme.v3.colors.white[0]};

	.deal-event-tab-rows {
		display: flex;
		align-items: center;
		padding: 0.5rem;
		border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	}

	/* The shared toolbar draws the edges of its own card; here the card is this one. */
	.deal-event-toolbar {
		border-width: 0 0 1px 0;
		border-radius: 0;
	}

	.mantine-table-scroll-area {
		border: none;
		border-radius: 0;
	}

	.deal-event-panels {
		display: flex;
		flex-direction: column;
		flex: 1;
		min-height: 0;
		overflow: hidden;
	}

	.deal-event-panel {
		display: flex;
		flex-direction: column;
		flex: 1;
		min-height: 0;
	}

	.deal-event-table-scroll {
		flex: 1;
		min-height: 0;
	}

	.deal-event-more {
		flex-shrink: 0;
		border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	}
`;
